import React, { Component } from 'react'
import { connect } from 'react-redux';

import { renderTextField } from '../../utils/engageComponents';
import { Field, reduxForm, change } from 'redux-form';

import PropTypes from 'prop-types';


import {GetCategoryIcons, AddCategory, UpdateCategory, DeleteCategory} from '../../actions/categoryActions'

import Grid from '@material-ui/core/Grid';
import { Modal, Fab, Paper } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';

import { InfoOutlined } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faCheckCircle, faLanguage } from '@fortawesome/free-solid-svg-icons';
import SelectIconModal from './SelectIconModal';
import { sweetAlert } from '../../components/Alert/sweetAlert';
import DeleteCategoryModal from './DeleteCategoryModal';

const colors=[
    '#47C372', '#571AFF', '#C400C4','#FF8408', '#F73C44',
    '#80CCA9','#9E88DB', '#C47CC4', '#DDAA64', '#C96B6F'
]   


const validate = (values) => {
    const errors = {};

    if (!values.name) {
        errors.name='Please write the name of the category'

    }else if(values.name.length>30){
        errors.name='The name of the category must be less than 30 characters'

    }


    if(values.nameEs && values.nameEs.length>30){
        errors.nameEs='The name of the category must be less than 30 characters'
    }

    if(values.nameFr && values.nameFr.length>30){
        errors.nameFr='The name of the category must be less than 30 characters'

    }

    return errors;
};


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};


TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


class AddEditCategory extends Component {

    constructor(props) {
        super(props);

        this.state = {
            _id:undefined,
            name: '',
            color: '',
            icon:'https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg',
            solidIcon:'',
            open:false,

            //Translations
            openTranslationsModal:false,
            nameEs:'',
            nameFr:'',
            tab:0
        };

        if (props.data) {

            this.props.dispatch(change('CategoryForm', '_id', props.data._id ? props.data._id : ''));
            this.props.dispatch(change('CategoryForm', 'name', props.data.name ? props.data.name : ''));

        } else {
            this.props.dispatch(change('CategoryForm', '_id', ''));
            this.props.dispatch(change('CategoryForm', 'name', ''));
        }
    };

    componentDidMount(){
        this.props.GetCategoryIcons();

        if(this.props.data){
            document.title='Activities - Edit Category'

            this.setState({
                _id:this.props.data._id,
                name:this.props.data.name,
                icon:this.props.data.iconUrl, 
                solidIcon:this.props.data.solidIconUrl, 
                color:this.props.data.categoryColor.toUpperCase()
            });


            const { translations } = this.props.data;

            if (translations && translations.length > 0) {

                const spanishObj = translations.find(x => x.languageCode === 'es');
                const frenchObj = translations.find(x => x.languageCode === 'fr');

                if (spanishObj) {
                    this.setState({ nameEs: spanishObj.name });
                    this.props.dispatch(change('CategoryForm', 'nameEs', spanishObj.name));

                }

                if (frenchObj) {
                    this.setState({ nameFr: frenchObj.name });
                    this.props.dispatch(change('CategoryForm', 'nameFr', frenchObj.name));

                }

            }
        
        }else{
            document.title='Activities - Add Category'

            //Search for an avalible color and select the one avalible
            for (let i = 0; i < colors.length; i++) {
                const alreadyInUse=this.props.categoryData.find(x=>x.categoryColor.toUpperCase()===colors[i]);

                if(!alreadyInUse){
                    this.setState({color:colors[i]})
                    break;
                }            
            }
        }
      

    }

    handleChangeIndex = (index) => {
        this.setState({ tab: index })
    };

    handleTabChange = (event, newValue) => {
        this.handleChangeIndex(newValue);
    };

    a11yProps = (index) => {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    };

    handleCancelTranslations = () => {
        this.setState({openTranslationsModal: false, nameEs: '', nameFr: '' })
        this.props.dispatch(change('CategoryForm', 'nameEs', ''));
        this.props.dispatch(change('CategoryForm', 'nameFr', ''));
    }



    handleSelectColor=(e,color)=>{
        
        // const alreadyInUse=this.props.categoryData.find(x=>x.categoryColor.toUpperCase()===color);

        // if(!alreadyInUse || this.props?.data?.categoryColor===color){
            this.setState({color:color}, ()=>this.CheckValues());
        // }

        
    }

    handleSelectIcon=(icon)=>{
        this.setState({icon:icon.iconUrl, solidIcon:icon.solidIconUrl, open:false},()=>this.CheckValues())

    }

    CheckValues=()=>{
        if(this.props.data){

            const { translations } = this.props.data;

            const spanishObj = translations?.find(x => x.languageCode === 'es');
            const frenchObj = translations?.find(x => x.languageCode === 'fr');

            if( (this.state.name && this.state.name!=='' && this.state.name!==this.props.data.name )
                || this.state.icon!==this.props.data.iconUrl || this.state.color!==this.props.data.categoryColor
                || (spanishObj && spanishObj?.name!==this.state.nameEs) || (frenchObj && frenchObj?.name!==this.state.nameFr)
            ){
                (this.props.buttonState) && this.props.enableButton();
            }else{
                (!this.props.buttonState)&& this.props.disableButton();

            }

        }else{

            if( this.state.name!=='' && this.state.color!=='' && this.state.icon!=='https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg'){

                (this.props.buttonState) && this.props.enableButton();
    
            }else{

                (!this.props.buttonState) && this.props.disableButton();
            }
        }
    }


    handleDelete=()=>{

        if(this.props.data){

            this.setState({
                openDeleteModal:true,
    
            })
        }

      
    }

    handleDeleteCategory =()=>{
        if(this.props.data){
            this.props.DeleteCategory(this.props.data._id);
        }

        this.props.close();
    }

    handleSubmit=()=>{
        if(!this.state.icon || this.state.icon==='https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg'){
            sweetAlert('error','Please select and icon');
            return;
        }

        if(!this.state.name || this.state.name==='Category Name'){
            sweetAlert('error','Please write the name of the category');
            return;
        }

        const obj = {
            iconUrl:this.state.icon,
            solidIconUrl:this.state.solidIcon,
            name:this.state.name,
            categoryColor:this.state.color,
            communityId:localStorage.getItem('communityId'),
            translations:[]
        }

        if (this.state.nameEs !== '') {
            const spanishObj = {
                languageCode: 'es',
                name: this.state.nameEs,
            }

            obj.translations.push(spanishObj);
        }

        if (this.state.nameFr !== '') {
            const frenchObj = {
                languageCode: 'fr',
                name: this.state.nameFr,
            }

            obj.translations.push(frenchObj);
        }

        if(this.props.data){ //update

            obj._id=this.state._id
            this.props.UpdateCategory(this.props.data._id, obj);

        }else{ //add
            this.props.AddCategory(obj);
        }

        setTimeout(() => {
            this.props.close();
          }, 500);
    }
    
    render() {
        return (
            <>
                <div className="imgalignrigth-engage appbtn-details-engage">
                    <div id="save_category_btn" className="appbtn-engage skybluebtn-engage" onClick={this.handleSubmit}>
                        Save
                    </div>
                    <div id="cancel_category_btn" className="appbtn-engage redbtn-engage">
                        Cancel
                    </div>
                    <div id="delete_category_btn" className="appbtn-engage redbtn-engage" onClick={this.handleDelete}>
                        Delete
                    </div>
                </div>
                <form>
                <Grid item container xs={12} style={{padding:'20px'}} alignItems='flex-start'>
                    {/* General Info */}
                    <Grid item container xs={12} sm={6} md={6} lg={4} style={{paddingRight:'1.5rem'}}>
                        <Grid item xs={12} className='setUpTitleEngage' >
                            General Info
                        </Grid>

                        <Grid item container xs={12} className="setUpGridColum">
                            <Grid item xs={12}>
                                <Field
                                    name="name"
                                    label="Name"
                                    placeholder='Category Name'
                                    maxLength={20}
                                    onChange={(e, newItem) => this.setState({ name: newItem })}
                                    component={renderTextField}
                                    onBlur={this.CheckValues}
                                    id='Category_name'
                                />

                                <Grid item container alignContent='center' justifyContent='flex-end' style={{paddingRight:'15px'}}>
                                    {
                                        (this.state?.name?.length > 0)?
                                        <Grid item> {`${this.state.name.length}/30`}</Grid>
                                        :
                                        undefined
                                    }
                                </Grid> 
                            </Grid>

                            

                            <Grid className='MuiFormLabel-root' style={{marginTop:'1rem'}}>Category color</Grid>

                            <Grid item container xs={12} justify='space-between'>

                                {
                                    colors.map(c=>{

                                        const selected = this.props.categoryData.find(x=>x.categoryColor.toUpperCase()===c)

                                        return(
                                            <Grid item container justify='center' alignItems='center' style={{backgroundColor:c}} className="categoryColor" onClick={(e)=>this.handleSelectColor(e,c)} key={`color_${c}`}>
                                                {
                                                    (selected && this.props?.data?.categoryColor!==c && this.state.color!==c) &&
                                                    <FontAwesomeIcon
                                                        icon={faBan}
                                                        color='white'
                                                        style={{opacity:'0.32'}}
                                                        size='2x'
                                                    />
                                                }
                                                {
                                                    this.state.color===c &&
                                                    <FontAwesomeIcon 
                                                        icon={faCheckCircle}
                                                        color='white'
                                                        size='2x'
                                                    />
                                                }
                                             
                                            </Grid>
                                        )
                                    })
                                }

                            </Grid>

                        </Grid>

                        <Grid item container xs={12} style={{marginTop:'1rem'}}>

                            <Grid item xs={1}>
                                <InfoOutlined fontSize='large'/>
                            </Grid>
                            <Grid item xs={11} style={{color:"#F0EFEF", opacity:"0.56", fontFamily:"Gotham-Book", fontSize:"20px", paddingLeft:'1rem'}}>
                                The color is used to distinguish the different categories throughout the Engage360 interface and for printed calendars.
                            </Grid>

                        </Grid>

                      
                    </Grid>

                    {/* Icon */}
                    <Grid item container xs={12} sm={6} md={6} lg={4}>
                        <Grid item xs={12} className='setUpTitleEngage' >
                            Icon
                        </Grid>

                        <Grid item container xs={12} className="setUpGridColum">
                            <Grid item container xs={12} justify='center'>
                                <img
                                    src={this.state.icon}
                                    alt="Icon"
                                    width='213px'
                                    height='156px'
                                    style={{opacity:(this.state.icon==='https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg')?'56%':'100%'}}
                                />
                            </Grid>

                            <Grid item container xs={12} justify='center' style={{marginTop:'2rem'}}>
                                <Grid id='Select_Icon_Btn' item className="appbtn-engage skybluebtn-engage appbtnBarButton" onClick={()=>this.setState({open:true})}>
                                    Select Icon
                                </Grid>
                            </Grid>

                          
                        </Grid>

                        <Grid item container xs={12} style={{marginTop:'1rem'}}>

                            <Grid item xs={1}>
                                <InfoOutlined fontSize='large'/>
                            </Grid>
                            <Grid item xs={11} style={{color:"#F0EFEF", opacity:"0.56", fontFamily:"Gotham-Book", fontSize:"20px", paddingLeft:'1rem'}}>
                                The icon is used to distinguish the different categories on the residents’ TVs.
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>

                <Modal
                    open={this.state.open}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ borderRadius: '16px' }}
                    onClose={() => this.setState({open:false})}
                >

                    <SelectIconModal
                        onDone={this.handleSelectIcon}
                        onCancel={()=>this.setState({open:false})}
                    />

                </Modal>


                <Fab
                    color='primary'
                    onClick={() => this.setState({ openTranslationsModal: true })}
                    classes={{
                        root: 'fab',
                        primary: "fabColor"
                    }}
                    size="large"
                >
                    <FontAwesomeIcon
                        icon={faLanguage}
                        color='white'
                        size='2x'
                    />
                </Fab>

                <Modal
                    open={this.state.openTranslationsModal}
                    onClose={() => {
                        this.setState({ openTranslationsModal: false })
                        this.CheckValues()
                
                    }}
                >

                    <Paper elevation={3}>
                        <Grid className="translationsModal" >
                            <Grid className="ModalTitle">Add translations</Grid>
                            <Grid item container xs={12} style={{ marginTop: '1rem', marginBotton: '1rem' }}>
                                <Tabs
                                    value={this.state.tab}
                                    onChange={this.handleTabChange}
                                    aria-label="Translations tab"
                                    className='translationTabs'
                                    TabIndicatorProps={{ style: { backgroundColor: '#009edd' } }}
                                >
                                    <Tab label="ES" className={(this.state.tab === 0) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(0)} />
                                    <Tab label="FR" className={(this.state.tab === 1) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(1)} />
                                </Tabs>

                                <SwipeableViews
                                    axis='x'
                                    index={this.state.tab}
                                    onChangeIndex={this.handleChangeIndex}
                                    style={{width:'100%'}}
                                >

                                    <TabPanel value={0} index={0} className='translationTabContent'>
                                        <Grid item container xs={12} style={{ marginTop: '1rem' }}>
                                            <Grid item xs={12}>
                                                <Field
                                                    name="nameEs"
                                                    label="Categoria"
                                                    maxLength={20}
                                                    onChange={(e, newItem) => this.setState({ nameEs: newItem })}
                                                    component={renderTextField}
                                                    id='category_name_es'
                                                />

                                                <Grid item container alignContent='center' justifyContent='flex-end' style={{fontFamily:'Gotham-Bold', fontSize:'20px', color:"#F0EFEF", opacity:'0.56'}}>
                                                    {
                                                        (this.state?.nameEs?.length > 0)?
                                                        <Grid item> {`${this.state.nameEs.length}/30`}</Grid>
                                                        :
                                                        undefined
                                                    }
                                                </Grid> 
                                            </Grid>
                                        </Grid>
                                    </TabPanel>

                                    <TabPanel value={1} index={1} className='translationTabContent'>
                                        <Grid item container xs={12} style={{ marginTop: '1rem' }}>
                                            <Grid item xs={12}>
                                                <Field
                                                    name="nameFr"
                                                    label="Catégorie"
                                                    maxLength={20}
                                                    onChange={(e, newItem) => this.setState({ nameFr: newItem })}
                                                    component={renderTextField}
                                                    id='category_name_fr'
                                                />
                                                <Grid item container alignContent='center' justifyContent='flex-end' style={{fontFamily:'Gotham-Bold', fontSize:'20px', color:"#F0EFEF", opacity:'0.56'}}>
                                                    {
                                                        (this.state?.nameFr?.length > 0)?
                                                        <Grid item> {`${this.state.nameFr.length}/30`}</Grid>
                                                        :
                                                        undefined
                                                    }
                                                </Grid> 

                                            </Grid>
                                              
                                        </Grid>
                                    </TabPanel>

                                </SwipeableViews>


                                </Grid>

                                <Grid item container xs={12} alignItems='center' justify='center' style={{ marginTop: '2rem'}}>
                                    <Grid
                                        item container justify='center' alignItems='center'
                                        onClick={this.handleCancelTranslations}
                                        className='RepairsModalButtonCancel alingCenter'
                                    >
                                        Cancel
                                    </Grid>
                                    <Grid
                                        item container justify='center' alignItems='center'
                                        onClick={() => {
                                            this.setState({ openTranslationsModal: false })
                                            this.CheckValues()
                                    
                                        }}
                                        className='RepairsModalButtonSchedule alingCenter'
                                    >
                                        Ok
                                    </Grid>
                                </Grid>



                            </Grid>
                        </Paper>

                    </Modal>

                    <Modal
                        open={this.state.openDeleteModal}
                        onClose={() =>this.setState({ openDeleteModal: false })}
                    >
                        <DeleteCategoryModal
                            category={this.props.data}
                            close={() =>this.setState({ openDeleteModal: false })}
                            onDelete={this.handleDeleteCategory}
                        />
                    </Modal>
                    </form>



            
            </>
        )
    }
}


function mapStateToProps(state) {
    const categoryData = (state.categoryReducer && state.categoryReducer.categoryData) ? state.categoryReducer.categoryData : [];



    return {
        categoryData,
    }
};

export default connect(mapStateToProps, {GetCategoryIcons, AddCategory, UpdateCategory, DeleteCategory})(reduxForm({
    form: 'CategoryForm',
    validate,
    enableReinitialize: true,
})(AddEditCategory));